module.exports = __webpack_public_path__ + "img/ae.9df491b1.svg";